const config = {
	keyFormat: /^[a-fA-F0-9]{8}(-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})?$/,
	newSetKey: 'new',
	lastUsedKeyName: 'line-last-used'
};

export default config;
